import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { submitLead } from "@/lib/api";

const EMPTY = { name: "", email: "", phone: "", organization: "", message: "" };

export default function LeadForm({ type, extra = [], submitLabel = "Submit", idPrefix }) {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitLead({ type, ...form });
      toast.success("Received. We will be in touch with you soon.");
      setForm(EMPTY);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form data-testid={`${idPrefix}-form`} onSubmit={onSubmit} className="grid gap-4">
      <div className="grid sm:grid-cols-2 gap-4">
        <input data-testid={`${idPrefix}-name-input`} required value={form.name} onChange={set("name")}
          placeholder="Full name" className="field-input" />
        <input data-testid={`${idPrefix}-email-input`} required type="email" value={form.email} onChange={set("email")}
          placeholder="Email address" className="field-input" />
      </div>
      {extra.includes("phone") && (
        <input data-testid={`${idPrefix}-phone-input`} value={form.phone} onChange={set("phone")}
          placeholder="Phone (optional)" className="field-input" />
      )}
      {extra.includes("organization") && (
        <input data-testid={`${idPrefix}-organization-input`} value={form.organization} onChange={set("organization")}
          placeholder="Church / Organization (optional)" className="field-input" />
      )}
      {extra.includes("message") && (
        <textarea data-testid={`${idPrefix}-message-input`} value={form.message} onChange={set("message")} rows={4}
          placeholder="Tell us more (optional)" className="field-input resize-none" />
      )}
      <button data-testid={`${idPrefix}-submit-button`} type="submit" disabled={loading}
        className="group inline-flex w-fit items-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-amber-400 to-violet-500 text-white text-base font-bold uppercase tracking-[0.12em] shadow-[0_10px_35px_-10px_rgba(139,92,246,0.6)] hover:shadow-[0_10px_45px_-8px_rgba(245,158,11,0.6)] hover:brightness-110 hover:scale-[1.03] active:scale-95 disabled:opacity-60 transition-all duration-300">
        {loading ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} className="transition-transform duration-300 group-hover:translate-x-1" />}
        {loading ? "Sending..." : submitLabel}
      </button>
    </form>
  );
}
